import { SxProps, Theme, Typography, TypographyProps } from "@mui/material";
import { FONT_COLOR_GENERAL, FONT_FAMILY, FONT_SIZE, FONT_WEIGHT_BOLD, TEXT_ALIGN } from "../global-config/BaseConfig";

/**
 * Default Styling
 */
const sxCoreHeader: SxProps<Theme> = {
	color: FONT_COLOR_GENERAL,

	fontSize: FONT_SIZE,
	fontWeight: FONT_WEIGHT_BOLD,
	fontFamily: FONT_FAMILY,

	textAlign: TEXT_ALIGN,
};

/**
 * Define props and a handler for common use cases (sx)
 */
type SxOverrides = {
	ellipsis?: boolean;
};

const SxOverrideHandler = (sxDefault: SxProps<Theme>, sxOverrides?: SxOverrides) => {
	if (!sxOverrides) {
		return sxDefault;
	}

	let sx = { ...sxDefault };

	sx = sxOverrides?.ellipsis ? { ...sx, textOverflow: "ellipsis", textWrap: "nowrap", overflow: "hidden" } : sx;

	return sx;
};

/**
 * Additional props for functions internal logic
 */
type InternalLogic = {
	dummyLogic?: boolean;
};

/**
 * Type for all the props in the main component
 */
type CoreHeaderProps = TypographyProps & SxOverrides & InternalLogic;

/**
 * Default styled container to display text content
 */
export const CoreHeader = (props: CoreHeaderProps) => {
	/* Apply overrides if existent */
	const { ellipsis, children, sx, ...rest } = props;
	const sxDefault: SxProps<Theme> = SxOverrideHandler(sxCoreHeader, { ellipsis });

	return (
		<Typography sx={{ ...sxDefault, ...sx }} {...rest}>
			{children}
		</Typography>
	);
};
